import requestor from "requestor";

import BaseRoute from "utils/base_route";
import getRouteIds from "utils/get_route_ids";

import DocumentDetailContainer from "routes/document_detail/containers/document_detail";

import dcDocumentFetchAction from "modules/documents/actions/dc_document_fetch";
import documentsFetchAction from "modules/documents/actions/documents_fetch";
import matterDocumentTopicsFetchAction from "modules/documents/actions/matter_document_topics_fetch";
import topicCategoriesFetchAction from "modules/documents/actions/topic_categories_fetch";
import topicTagsFetchAction from "modules/documents/actions/topic_tags_fetch";
import contractTypesFetchAction from "modules/documents/actions/contract_types_fetch";
import documentStateFetchAction from "modules/documents/actions/document_state/fetch";
import definitionGroupsFetchAction from "modules/documents/actions/definition_group/definition_groups_fetch";
import projectFetchAction from "modules/projects/actions/project_fetch";
import rolesFetchAction from "modules/documents/actions/role/roles_fetch";
import matterFetchAction from "modules/matters/actions/fetch_matter";

import documentClearAction from "modules/documents/actions/document_clear";
import topicsClearAction from "modules/documents/actions/topics_clear";
import topicCategoriesClearAction from "modules/documents/actions/topic_categories_clear";
import topicTagsClearAction from "modules/documents/actions/topic_tags_clear";
import contractTypesClearAction from "modules/documents/actions/contract_types_clear";
import searchClearAction from "modules/search/actions/search_clear";
import documentStateClearAction from "modules/documents/actions/document_state/clear";
import logsClearAction from "modules/logs/actions/logs_clear";
import definitionGroupsClearAction from "modules/documents/actions/definition_group/definition_groups_clear";
import clearMatterAction from "modules/matters/actions/clear_matter";

export default class MatterDocumentDetail extends BaseRoute {
  constructor(store, path) {
    super(path, store);
  }

  getComponents(location, cb) {
    cb(null, DocumentDetailContainer);
  }

  fetchActiveData(props) {
    this.fetchMatter(props);
    this.fetchProject(props);
    this.fetchDocuments(props);
    this.fetchDocumentClauses(props);
    this.fetchTopics(props);
    this.fetchTopicCategories(props);
    this.fetchTopicTags(props);
    this.fetchContractTypes(props);
    this.fetchDocumentStates(props);
    this.fetchDefinitionGroups(props);
    this.fetchRoles(props);
  }

  fetchDocuments(props) {
    const {organisationId, projectId} = getRouteIds(props.router);
    this.store.dispatch(
      documentsFetchAction(requestor)(organisationId, projectId),
    );
  }

  fetchDocumentClauses(props) {
    const {organisationId, projectId, matterId, documentId} = getRouteIds(
      props.router,
    );
    if (documentId && matterId) {
      this.store.dispatch(
        dcDocumentFetchAction(requestor)(
          organisationId,
          projectId,
          matterId,
          documentId,
          {
            fetch_issue_progress: true,
          },
        ),
      );
    }
  }

  fetchTopics(props) {
    const {organisationId, projectId, matterId, documentId} = getRouteIds(
      props.router,
    );
    this.store.dispatch(
      matterDocumentTopicsFetchAction(requestor)(
        organisationId,
        projectId,
        matterId,
        documentId,
      ),
    );
  }

  fetchTopicCategories(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(topicCategoriesFetchAction(requestor)(organisationId));
  }

  fetchTopicTags(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(topicTagsFetchAction(requestor)(organisationId));
  }

  fetchContractTypes(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(contractTypesFetchAction(requestor)(organisationId));
  }

  fetchDocumentStates(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(documentStateFetchAction(organisationId));
  }

  fetchDefinitionGroups(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(definitionGroupsFetchAction(requestor)(organisationId));
  }

  fetchProject(props) {
    const {organisationId, projectId} = getRouteIds(props.router);
    if (projectId) {
      this.store.dispatch(
        projectFetchAction(requestor)(organisationId, projectId),
      );
    }
  }

  fetchMatter(props) {
    const {organisationId, projectId, matterId} = getRouteIds(props.router);
    this.store.dispatch(
      matterFetchAction(requestor)(organisationId, projectId, matterId),
    );
  }

  fetchRoles(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(rolesFetchAction(requestor)(organisationId));
  }

  clearActiveData(props) {
    const {organisationId, projectId, documentId} = getRouteIds(props.router);
    this.store.dispatch(
      documentClearAction(organisationId, projectId, documentId),
    );
    this.store.dispatch(topicsClearAction(organisationId));
    this.store.dispatch(topicCategoriesClearAction(organisationId));
    this.store.dispatch(topicTagsClearAction(organisationId));
    this.store.dispatch(contractTypesClearAction());
    this.store.dispatch(searchClearAction());
    this.store.dispatch(documentStateClearAction());
    this.store.dispatch(logsClearAction());
    this.store.dispatch(clearMatterAction());
    this.store.dispatch(definitionGroupsClearAction());
  }
}
